<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"></span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="line-item-form__wrapper">
      <div class="invoice-line-items-form_wrapper">
        <div class="mb-5">
          Showing total of <strong>{{ totalRfq }}</strong> item(s)
        </div>

        <div class="lum-filters__container">
          <lum-filter
            buttonIconColor="#ffffff"
            filterId="lum-rfq-lineitem-filter"
            [filters]="filters"
            (queryBuildEvent)="onQueryBuild($event)"
          ></lum-filter>
        </div>

        <lum-rfq-line-items-table
          [rfqs]="rfqs$ | async"
          [loading]="(loading$ | async) || false"
          [form]="form"
        ></lum-rfq-line-items-table>
      </div>
    </div>

    <div class="lum-invoice-line-items__action flex mt-4 w-p100">
      <div class="flex ml-auto lum-modal__action">
        <button
          type="button"
          class="lum-button lum-button--secondary lum-button--large mx-1"
          (click)="onClose()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="lum-button lum-button--primary lum-button--large mx-1"
          (click)="onSubmit()"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>
